export const toAnchor = urlHelper => value => urlHelper.toAnchor(value);
toAnchor.$inject = ["urlHelper"];